<app-header></app-header>
<ion-content
  *ngIf="(inventoryLandingPageData$ | async) as inventoryLandingPageData"
  id="inventory"
  class="gray-content-bg"
  [ngClass]="(platformService?.isTouchExperience$ | async) ? platformService?.platformType === platformService?.platformEnum?.tablet ? 'tablet' : 'mobile' : 'desktop'"
>
  <ng-container
    *ngIf="!!inventoryLandingPageData?.isInventoryDataLoaded else inventoryLandingSkeleton"
  >
    <cdk-virtual-scroll-viewport
      appInvVs
      [indexOffset]="1"
      [itemHeights]="inventoryLandingPageData?.itemHeights"
    >
      <!-- Page Title -->
      <app-page-title-banner
        *ngIf="(platformService?.isTouchExperience$ | async) === false"
        [pageTitle]="'i18n.inventory.inventoryTitle' | translate"
        [backgroundImageStyle]="backgroundImageStyle"
        [overlayGradient]="overlayGradient"
        [showEllipsis]="ellipsisFlag$ | async"
        (ellipsisClickEventEmitter)="openOtherInventoryActions($event, inventoryLandingPageData)"
      ></app-page-title-banner>

      <ion-grid
        data-cy="inventory-content"
        class="inventory-content"
        [class.hide]="!inventoryLandingPageData?.isInventoryDataLoaded"
        [fixed]="true"
      >
        <!-- Desktop/Tablet -->
        <ng-container
          *ngIf="platformService?.platformType !== platformService?.platformEnum?.mobile; else mobileInventories"
        >
          <!-- Tiles -->
          <ng-container *ngIf="(migrationData$ | async) as migrationData">
            <ng-container *ngIf="(migrationFlag$ | async)">
              <ion-row
                *ngIf="migrationData.hasR2Inventory && migrationData.customerMigrated ===  MigrationStatus.ERROR && migrationData.withinThreeDays"
              >
                <ion-card
                  *ngIf="(selectedCustomer$ | async) as customer"
                  class="inventory-migration-error-tile"
                >
                  <div
                    class="migration-row between"
                    [class.with-button]="platformService?.platformType === platformService?.platformEnum?.tablet"
                  >
                    <div
                      class="migration-message"
                      [class.initial]="platformService?.platformType === platformService?.platformEnum?.tablet"
                    >
                      <h2>
                        {{ 'i18n.inventory.inventoryMigration.yourDataTransfer'
                        | translate}}
                      </h2>
                      <p
                        [class.tablet-message]="platformService?.platformType === platformService?.platformEnum?.tablet"
                      >
                        {{
                        'i18n.inventory.inventoryMigration.pleaseContactCustomerHelpDesk'
                        | translate}}
                      </p>
                    </div>

                    <div>
                      <ion-button
                        class="usf-outline-green-dsktp-tblt-modal-button"
                        (click)="goToR2PastInventories()"
                        *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
                      >
                        {{
                        'i18n.inventory.inventoryMigration.viewPastInventories'
                        | translate}}
                      </ion-button>
                    </div>
                  </div>
                </ion-card>
              </ion-row>
              <ion-row
                *ngIf="migrationData.hasR2Inventory && migrationData.customerMigrated ===  MigrationStatus.SUCCESS && migrationData.withinThreeDays"
              >
                <ion-card
                  *ngIf="(selectedCustomer$ | async) as customer"
                  class="inventory-migration-success"
                >
                  <div class="migration-row success">
                    <ion-icon src="assets/images/alert-green.svg"></ion-icon>
                    <div class="migration-message with-button">
                      <h2>
                        {{
                        'i18n.inventory.inventoryMigration.yourPastDataSuccess'
                        | translate}}
                      </h2>
                      <div class="transfer-buttons-success">
                        <ion-button
                          class="usf-outline-green-dsktp-tblt-modal-button"
                          (click)="goToR2PastInventories()"
                          *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
                        >
                          {{
                          'i18n.inventory.inventoryMigration.viewPastInventories'
                          | translate}}
                        </ion-button>
                        <ion-button
                          class="usf-fill-green-dsktp-tblt-modal-button"
                          (click)="goToAllInventories()"
                          data-cy="migration-banner-all-inventories-button"
                        >
                          {{
                          'i18n.inventory.inventoryMigration.goToYourInventories'
                          | translate}}
                        </ion-button>
                      </div>
                    </div>
                  </div>
                </ion-card>
              </ion-row>
              <ion-row
                *ngIf="migrationData.hasR2Inventory && !migrationData.customerMigrated"
              >
                <ion-card
                  *ngIf="(selectedCustomer$ | async) as customer"
                  class="inventory-migration-tile"
                >
                  <div
                    class="migration-row between"
                    [class.with-button]="platformService?.platformType === platformService?.platformEnum?.tablet"
                  >
                    <div
                      class="migration-message"
                      [class.initial]="platformService?.platformType === platformService?.platformEnum?.tablet"
                    >
                      <h2>
                        {{
                        'i18n.inventory.inventoryMigration.dontForgetToTransfer'
                        | translate}}
                      </h2>
                      <p>
                        {{ 'i18n.inventory.inventoryMigration.onceTransferred' |
                        translate}}
                      </p>
                    </div>
                    <div class="transfer-buttons">
                      <ion-button
                        class="usf-outline-green-dsktp-tblt-modal-button"
                        (click)="goToR2PastInventories()"
                        *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
                      >
                        {{
                        'i18n.inventory.inventoryMigration.viewPastInventories'
                        | translate}}
                      </ion-button>

                      <ion-button
                        class="usf-fill-green-dsktp-tblt-modal-button"
                        (click)="openMigrationConfirmationModal(customer.customerName, customer.customerNumber, customer.departmentNumbers)"
                      >
                        {{ 'i18n.inventory.inventoryMigration.transferPastData'
                        | translate}}
                      </ion-button>
                    </div>
                  </div>
                </ion-card>
              </ion-row>
              <ion-row
                *ngIf="migrationData.hasR2Inventory && migrationData.customerMigrated === MigrationStatus.IN_PROGRESS"
              >
                <ion-card
                  *ngIf="(selectedCustomer$ | async) as customer"
                  class="inventory-migration-tile progress"
                >
                  <div class="migration-row">
                    <ion-spinner
                      name="circles"
                      data-cy="loading-spinner-icon"
                    ></ion-spinner>
                    <div class="migration-message">
                      <h2
                        *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
                      >
                        {{
                        'i18n.inventory.inventoryMigration.dataBeingTransferred'
                        | translate}} {{
                        'i18n.inventory.inventoryMigration.notifyYou' |
                        translate}}
                      </h2>
                      <ng-container
                        *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
                      >
                        <h2>
                          {{
                          'i18n.inventory.inventoryMigration.dataBeingTransferred'
                          | translate}}
                        </h2>
                        <h2>
                          {{ 'i18n.inventory.inventoryMigration.notifyYou' |
                          translate}}
                        </h2>
                      </ng-container>
                    </div>
                  </div>
                </ion-card>
              </ion-row>
            </ng-container>
          </ng-container>
          <ion-row>
            <ion-col
              [size]="inventoryLandingPageData?.inventories?.length !== 0 ? '5.625' : '12'"
            >
              <ion-card class="create-inventory-tile">
                <div
                  [style.background]="tileGradient"
                  class="inventory-tile-overlay"
                >
                  <h2 data-cy="inventory-tile-create-title">
                    {{ 'i18n.inventory.inventoryCreateTitle' | translate}}
                  </h2>
                  <p data-cy="inventory-tile-create-description">
                    {{ 'i18n.inventory.inventoryCreateDescription' | translate}}
                  </p>
                  <ion-button
                    data-cy="inventory-tile-create-button"
                    class="usf-outline-green-button"
                    (click)="goToCreateInventory()"
                  >
                    {{ 'i18n.inventory.inventoryCreateButton' | translate}}
                  </ion-button>
                </div>
              </ion-card>
            </ion-col>
            <ion-col
              *ngIf="inventoryLandingPageData?.inventories?.length !== 0"
              size="5.625"
              offset="0.75"
            >
              <ion-card class="all-inventory-tile">
                <div
                  [style.background]="tileGradient"
                  class="inventory-tile-overlay"
                >
                  <h2 data-cy="inventory-tile-all-title">
                    {{ 'i18n.inventory.inventoryAllTitle' | translate}}
                  </h2>
                  <p data-cy="inventory-tile-all-description">
                    {{ 'i18n.inventory.inventoryAllDescription' | translate}}
                  </p>
                  <ion-button
                    data-cy="inventory-tile-all-button"
                    class="usf-outline-green-button"
                    (click)="goToAllInventories()"
                  >
                    {{ 'i18n.inventory.inventoryAllButton' | translate}}
                  </ion-button>
                </div>
              </ion-card>
            </ion-col>
          </ion-row>
          <!-- Recent Inventories Desktop -->
          <app-inventory-section-desktop
            *ngIf="(platformService?.isTouchExperience$ | async) === false"
            [sectionHeaders]="inventoryLandingPageData?.inventoriesSort?.inventories?.headers"
            [selectedHeader]="inventoryLandingPageData?.inventoriesSort?.inventories?.selectedHeader"
            [inventories]="inventoryLandingPageData?.inventories"
            [isInventoryLanding]="true"
            (openWorksheetEmitter)="goToInventoryWorksheet($event)"
            (updateSortEmitter)="updateSort($event)"
            (inventoryEllipsisEmitter)="openInventoryCardEllipsis($event, inventoryLandingPageData)"
            (copyInventoryEmitter)="copyInventory($event)"
          >
          </app-inventory-section-desktop>

          <!-- Recent Inventories Tablet -->
          <app-inventory-section-tablet
            *ngIf="(platformService?.isTouchExperience$ | async)"
            [sectionHeaders]="inventoryLandingPageData?.inventoriesSort?.inventories?.headers"
            [selectedHeader]="inventoryLandingPageData?.inventoriesSort?.inventories?.selectedHeader"
            [inventories]="inventoryLandingPageData?.inventories"
            [isInventoryLanding]="true"
            [tabletHeaderButtonText]="'i18n.inventory.otherInventoryActions' | translate"
            (headerButtonEventEmitter)="openOtherInventoryActions($event, inventoryLandingPageData)"
            (openWorksheetEmitter)="goToInventoryWorksheet($event)"
            (updateSortEmitter)="updateSort($event)"
            (inventoryEllipsisEmitter)="openInventoryCardEllipsis($event, inventoryLandingPageData)"
            (copyInventoryEmitter)="copyInventory($event)"
          >
          </app-inventory-section-tablet>
        </ng-container>

        <!-- Mobile -->
        <ng-template #mobileInventories>
          <!-- Tiles -->
          <ng-container *ngIf="(migrationData$ | async) as migrationData">
            <ng-container *ngIf="(migrationFlag$ | async)">
              <ion-row
                *ngIf="migrationData.hasR2Inventory && migrationData.customerMigrated ===  MigrationStatus.ERROR && migrationData.withinThreeDays"
                class="migration"
              >
                <ion-card
                  *ngIf="(selectedCustomer$ | async) as customer"
                  class="inventory-migration-error-tile"
                >
                  <div class="migration-row with-button">
                    <div class="migration-message">
                      <h2>
                        {{ 'i18n.inventory.inventoryMigration.yourDataTransfer'
                        | translate}}
                      </h2>
                      <p>
                        {{
                        'i18n.inventory.inventoryMigration.pleaseContactCustomerHelpDesk'
                        | translate}}
                      </p>
                    </div>
                    <ion-button
                      class="usf-fill-orange-dsktp-tblt-modal-button"
                      href="tel:+18775839659"
                    >
                      {{ 'i18n.inventory.inventoryMigration.callHelpDesk' |
                      translate}}
                    </ion-button>
                  </div>
                </ion-card>
              </ion-row>
              <ion-row
                *ngIf="migrationData.hasR2Inventory && !migrationData.customerMigrated"
                class="migration"
              >
                <ion-card
                  *ngIf="(selectedCustomer$ | async) as customer"
                  class="inventory-migration-tile"
                >
                  <div class="migration-row with-button">
                    <div class="migration-message">
                      <h2>
                        {{
                        'i18n.inventory.inventoryMigration.dontForgetToTransfer'
                        | translate}}
                      </h2>
                      <p>
                        {{ 'i18n.inventory.inventoryMigration.onceTransferred' |
                        translate}}
                      </p>
                    </div>
                    <div class="transfer-buttons-mobile">
                      <ion-button
                        class="usf-fill-green-dsktp-tblt-modal-button"
                        (click)="openMigrationConfirmationModal(customer.customerName, customer.customerNumber, customer.departmentNumbers)"
                      >
                        {{ 'i18n.inventory.inventoryMigration.transferPastData'
                        | translate}}
                      </ion-button>
                    </div>
                  </div>
                </ion-card>
              </ion-row>
              <ion-row
                *ngIf="migrationData.hasR2Inventory && migrationData.customerMigrated ===  MigrationStatus.SUCCESS && migrationData.withinThreeDays"
              >
                <ion-card
                  *ngIf="(selectedCustomer$ | async) as customer"
                  class="inventory-migration-success"
                >
                  <div class="migration-row">
                    <ion-icon src="assets/images/alert-green.svg"></ion-icon>
                    <div class="migration-message">
                      <h2 class="success">
                        {{
                        'i18n.inventory.inventoryMigration.yourPastDataSuccess'
                        | translate}}
                      </h2>
                      <ion-button
                        class="usf-fill-green-dsktp-tblt-modal-button"
                        (click)="goToAllInventories()"
                        data-cy="migration-banner-all-inventories-button"
                      >
                        {{
                        'i18n.inventory.inventoryMigration.goToYourInventories'
                        | translate}}
                      </ion-button>
                    </div>
                  </div>
                </ion-card>
              </ion-row>
              <ion-row
                *ngIf="migrationData.hasR2Inventory && migrationData.customerMigrated === MigrationStatus.IN_PROGRESS"
              >
                <ion-card
                  *ngIf="(selectedCustomer$ | async) as customer"
                  class="inventory-migration-tile"
                >
                  <div class="migration-row">
                    <ion-spinner
                      name="circles"
                      data-cy="loading-spinner-icon"
                    ></ion-spinner>
                    <div class="in-progress">
                      <ng-container>
                        <h2>
                          {{
                          'i18n.inventory.inventoryMigration.dataBeingTransferred'
                          | translate}}
                        </h2>
                        <h2>
                          {{ 'i18n.inventory.inventoryMigration.notifyYou' |
                          translate}}
                        </h2>
                      </ng-container>
                    </div>
                  </div>
                </ion-card>
              </ion-row>
            </ng-container>
          </ng-container>
          <ion-row>
            <ion-col
              [size]="inventoryLandingPageData?.inventories?.length !== 0 ? '5.625' : '12'"
            >
              <ion-card
                class="create-inventory-tile"
                (click)="goToCreateInventory()"
              >
                <div
                  [style.background]="tileGradient"
                  class="inventory-tile-overlay"
                >
                  <h2 data-cy="inventory-tile-create-title-mobile">
                    {{ 'i18n.inventory.inventoryCreateTitle' | translate}}
                  </h2>
                </div>
              </ion-card>
            </ion-col>
            <ion-col
              *ngIf="inventoryLandingPageData?.inventories?.length !== 0"
              size="5.625"
              offset="0.75"
            >
              <ion-card
                class="all-inventory-tile"
                (click)="goToAllInventories()"
              >
                <div
                  [style.background]="tileGradient"
                  class="inventory-tile-overlay"
                >
                  <h2 data-cy="inventory-tile-create-title-mobile">
                    {{ 'i18n.inventory.inventoryAllTitle' | translate}}
                  </h2>
                </div>
              </ion-card>
            </ion-col>
          </ion-row>
          <!-- Other Inventory Actions Dropdown -->
          <ion-row
            *ngIf="ellipsisFlag$ | async"
            class="other-inventory-actions"
          >
            <ion-col size="12">
              <ion-button
                class="usf-outline-green-button"
                (click)="openOtherInventoryActions($event, inventoryLandingPageData)"
              >
                <ion-label>
                  <span>
                    {{ 'i18n.inventory.otherInventoryActions' | translate }}
                  </span>
                  <ion-icon name="chevron-down"></ion-icon>
                </ion-label>
              </ion-button>
            </ion-col>
          </ion-row>
          <!-- Recent Inventories -->
          <app-inventory-section-mobile
            [selectedHeader]="inventoryLandingPageData?.inventoriesSort?.inventories?.selectedHeader"
            [inventories]="inventoryLandingPageData?.inventories"
            [isInventoryLanding]="true"
            (openWorksheetEmitter)="goToInventoryWorksheet($event)"
            (updateSortEmitter)="updateSort($event)"
            (inventoryEllipsisEmitter)="openInventoryCardEllipsis($event, inventoryLandingPageData)"
          >
          </app-inventory-section-mobile>
        </ng-template>
      </ion-grid>

      <app-footer></app-footer>
    </cdk-virtual-scroll-viewport>
  </ng-container>
  <ion-modal
    [isOpen]="inventoryService.showExtendedCostReport.value"
    (ionModalDidDismiss)="handleHideExtendedCostReport()"
    [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' :'modal-desktop-size-xl'"
    [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
    [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
  >
    <ng-template>
      <app-extended-cost-report-modal
        class="ion-page"
        [platformType]="platformService.platformType"
        (dismissEvent)="handleHideExtendedCostReport()"
        (submitEvent)="handleSubmitExtendedCostReport($event)"
      >
      </app-extended-cost-report-modal>
    </ng-template>
  </ion-modal>
</ion-content>

<!-- Inventory Landing Page Skeleton -->
<ng-template #inventoryLandingSkeleton>
  <ion-content>
    <app-inventory-landing-skeleton
      [platform]="platformService?.platformType"
    ></app-inventory-landing-skeleton>
    <app-footer></app-footer>
  </ion-content>
</ng-template>

<!-- Cost Report Modal (Dual Pane) -->
<app-cost-comparison-report-container
  [completedInventories$]="inventoriesForCostComparison$"
  (submitEvent)="handleCostComparisonSubmission($event)"
></app-cost-comparison-report-container>
